import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileSwitch: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiSwitch_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiSwitchRole',
      bindings: [
        {
          title: 'mobui_MobuiSwitch_dataBinding_value_label',
          prop: 'value',
          supportedFieldTypes: [FieldType.boolean],
          defaultFieldType: FieldType.boolean,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
